import { SanityComplexPortableText } from '@data/sanity/queries/types/content'

import ComplexPortableText from '@components/portable-text/complex'

interface ShopTemplateHeaderProps {
  title: string
  description: SanityComplexPortableText
}

const ShopTemplateHeader = ({
  title,
  description,
}: ShopTemplateHeaderProps) => {
  return (
    <div className="container py-12">
      <div className="max-w-[1000px] mx-auto">
        <h1 className="font-serif text-center mb-14">{title}</h1>

        <ComplexPortableText
          content={description}
          className="rc text-center mb-4"
        />
      </div>
    </div>
  )
}

export default ShopTemplateHeader
